/* Old Mountain Tea — exit-intent offer behaviour.
   Desktop: fires when the cursor leaves through the top of the viewport.
   Touch:  fires on dwell time or scroll depth, whichever comes first.
   Never before MIN_DELAY — an earlier trigger is held until the delay is up.
   Shown once per session (sessionStorage). If the customer form was just
   submitted, the dialog opens straight into its success state, and the cart
   gets a "Free sample" attribute. It shows on the order under Additional
   details, so the packer adds a sample of their choice. */
(function () {
  'use strict';
  var SEEN_KEY = 'omt_offer_seen';
  var MIN_DELAY = 10000;
  var overlay = document.getElementById('omt-offer');
  if (!overlay) return;

  var lastFocus = null;
  var shown = false;
  var started = Date.now();
  var pending = false;

  /* The offer photo ships as data-omt-src (see snippets/omt-exit-offer.liquid)
     so it doesn't compete with the page's own images. It is swapped in after
     the page has loaded, or immediately if the offer opens first. */
  var art = overlay.querySelector('img[data-omt-src]');
  function loadArt() {
    if (!art) return;
    art.src = art.getAttribute('data-omt-src');
    art.removeAttribute('data-omt-src');
    art = null;
  }

  function seen() { try { return sessionStorage.getItem(SEEN_KEY) === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {} }

  function open() {
    if (shown || overlay.classList.contains('in')) return;
    if (document.body.classList.contains('nav-open')) return;
    shown = true;
    markSeen();
    loadArt();
    lastFocus = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('in'); });
    document.body.style.overflow = 'hidden';
    var focusable = overlay.querySelector('input, button');
    if (focusable) setTimeout(function () { focusable.focus(); }, 240);
  }

  function close() {
    overlay.classList.remove('in');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 240);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Honour a trigger, but never open sooner than MIN_DELAY after load. */
  function requestOpen() {
    if (shown || pending) return;
    var wait = MIN_DELAY - (Date.now() - started);
    if (wait <= 0) { open(); return; }
    pending = true;
    setTimeout(function () { pending = false; open(); }, wait);
  }

  // Close handlers
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay || e.target.hasAttribute('data-omt-close')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!overlay.classList.contains('in')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = overlay.querySelectorAll('button, input, a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // If the form was just submitted, open straight into the success state.
  // The marker is rendered inside the form block, where form.posted_successfully? is in scope.
  if (overlay.querySelector('[data-omt-success]')) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Free sample': "Yes (newsletter sign-up, seller's choice; not with the Discovery Set)" } })
    }).catch(function () {});
    markSeen();
    open();
    return;
  }

  if (seen()) return;

  // Visitors who already saw the offer this session never download the photo.
  if (document.readyState === 'complete') setTimeout(loadArt, 1500);
  else window.addEventListener('load', function () { setTimeout(loadArt, 1500); });

  if (window.matchMedia('(pointer:fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 6) return;
      requestOpen();
    });
  } else {
    setTimeout(open, 28000);
    window.addEventListener('scroll', function onScroll() {
      var h = document.documentElement;
      var pct = (h.scrollTop + window.innerHeight) / h.scrollHeight;
      if (pct > 0.55) { window.removeEventListener('scroll', onScroll); requestOpen(); }
    }, { passive: true });
  }
})();
